import { Component, OnInit } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {ApiUrl} from "../../../shared/models/apiurl.models";

@Component({
  selector: 'app-background-video',
  templateUrl: './background-video.component.html',
  styleUrls: ['./background-video.component.scss']
})
export class BackgroundVideoComponent implements OnInit {
  private options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'

    })
  }

  public videoUrl: string;
  public title: string;
  public description: string;
  constructor(private http: HttpClient, private apiUrl:ApiUrl) { }

  ngOnInit(): void {
    this.loadData();
  }

  loadData(){
    this.http.get<any>(this.apiUrl.getVideo(),this.options).subscribe(res=>{
      this.title = res['results'][0]['title'];
      this.description = res['results'][0]['descriptions'];
      this.videoUrl = res['results'][0]['videoSrc'];
    })
  }

}
